module.exports = __webpack_public_path__ + "static/media/cancelled_pass.26452c76.svg";